export default __webpack_public_path__ + "static/media/concert-hall.603cfb81.jpg";